<template>
  <div>
    <div class="row" style="margin-top: 10px;">
      <div class="col-md-12 text-left">
        <h5 slot="header" class="card-title">Selecione a Câmera</h5>
        <div class="d-flex flex-row justify-content-between">
          <el-select
            class="select-success mb-1 pagination-select w-100"
            name="cam"
            id="cam"
            v-model="selected"
            placeholder="Selecione a Câmera"
            @change="changeCamera(selected)"
          >
            <el-option
              class="select-success"
              v-for="camera in cameras"
              :key="camera.deviceId"
              :label="camera.label"
              :value="camera.deviceId"
            >
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="col-md-12 text-left mt-1" v-if="matriculas.length > 1">
        <h5 slot="header" class="card-title">Selecione a Matrícula</h5>
        <div class="d-flex flex-row justify-content-between">
          <el-select
            class="select-success mb-1 pagination-select w-100"
            v-model="matriculaSelecionada"
            placeholder="Selecione a Matrícula"
          >
            <el-option
              class="select-success"
              v-for="item in matriculas"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>

    <div class="row" style="margin-top: 10px;">
      <div class="col-md-12 text-left">
        <video
          ref="video"
          :width="width"
          :height="height"
          :src="source"
          :autoplay="autoplay"
          :playsinline="playsinline"
        />
      </div>
    </div>

    <div class="row" style="margin-top: 10px;">
      <div class="col-md-12 text-left custom-button">
        <base-button
          native-type="submit"
          slot="footer"
          type="success"
          @click="CapturarImagem()"
          :disabled="isLoading"
          round
          block
          size="lg"
        >
          <i class="tim-icons icon-camera-18" /> Registrar Ponto
        </base-button>
      </div>
    </div>
    <Carregando v-if="isLoading" />
  </div>
</template>
<script>
// import Paciente from "../../classSamel/Paciente"
// import { bus } from "../../main"
import Carregando from "../../../src/pages/Loads/Carregando.vue";
import swal from "sweetalert2";
import moment from "moment-timezone";
import globalVariable from "../../globalVariable";
import jwt from "jsonwebtoken";

export default {
  name: "modal-rec-facial",
  components: {
    Carregando,
  },
  props: {
    pacientee: {
      type: Object,
      default: null,
    },
    /* configHeader: {
            type: Object,
            required: true
        }, */
    playsinline: {
      type: Boolean,
      default: true,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    width: {
      type: [Number, String],
      default: "100%",
    },
    height: {
      type: [Number, String],
      default: "100%",
    },
    resolution: {
      type: Object,
      default: null,
      validator: (value) => {
        return value.height && value.width;
      },
    },
  },
  data() {
    return {
      isLoading: false,
      showimg: true,
      cont: 0,
      load28: false,
      teste: null,
      modals: {
        modal3: false,
      },
      source: null,
      canvas: null,
      camerasListEmitted: false,
      cameras: [],
      photo: null,
      device: null,
      selected: "",
      cam: false,
      load_modal: false,
      showToken: false,
      showButtons: true,
      listProcedimentos: [],
      errorResponse: {
        status: false,
        message: "",
      },
      successResponse: {
        status: false,
        message: "",
      },
      dados: "",
      matriculas: [],
      matriculaSelecionada: null,
    };
  },
  watch: {},
  methods: {
    scrollToElement() {
      window.scrollTo(0, document.body.scrollHeight);
    },
    carregarDados() {
      this.dados = JSON.parse(this.$session.get("dados"));
      const dadosFacial = JSON.parse(this.$session.get("facial"));
      this.matriculas.push(dadosFacial.matricula);
      this.matriculaSelecionada = dadosFacial.matricula;
      if (dadosFacial.matricula2) {
        this.matriculas.push(dadosFacial.matricula2);
      }
    },
    moment: function(data) {
      return moment(data);
    },

    async registrarPonto(img) {
      const carregarDadosFacial = () => {
        let dados = JSON.parse(this.$session.get("facial"));

        if (this.dados.tipo === "E") dados.db = this.dados.db_name;
        else dados.db = this.dados.DB_NAME;

        return dados;
      };

      const dados = carregarDadosFacial();

      let thi = this;
      await this.$getLocation()
        .then((coordinates) => {
          this.coordenadas = coordinates;

          let th = this;
          this.isLoading = true;

          const fuso = dados.FUSO ? dados.FUSO : "America/Manaus";

          let bodyFormData = {
            setDB: dados.db,
            data_batida: this.moment()
              .tz(fuso)
              .format("DD/MM/YYYY"),
            hora_batida: this.moment()
              .tz(fuso)
              .format("HH:mm:ss"),
            latitude: this.coordenadas.lat,
            longitude: this.coordenadas.lng,
            endereco_por_extenso: "xxx",
            selfie_batida: img,
            id_empregados: dados.idEmpregado,
            id_empregador: dados.idEmpregador,
            id_tipo_batida: "1",
            matricula: this.matriculaSelecionada,
          };

          this.axios
            .post("/api/movimentacoes/baterPonto", bodyFormData)
            .then((response) => {
              const data = response.data;

              th.isLoading = false;

              if (data.status === "success") {
                let ms =
                  response.data.data.dados_batida[0].DATA_BATIDA +
                  " - " +
                  response.data.data.dados_batida[0].HORA_BATIDA;
                th.showSwal2("auto-close", "Ponto Registrado", ms, "success");
                setTimeout(() => {
                  if (this.dados.tipo == "F") {
                    this.$cookies
                      .keys()
                      .forEach((cookie) => this.$cookies.remove(cookie));
                    this.$session.clear("w_");
                    this.$session.clear("dados");
                    this.$session.clear("facial");
                    this.$router.push("/login");
                  }
                }, 500);
                setTimeout(() => {
                  jwt.verify(
                    this.$session.get("w_"),
                    globalVariable.KEY_LEVEL_7,
                    function(err, decoded) {
                      if (decoded) {
                        location.reload();
                      } else {
                        th.$root.$emit("responseRecFacial", true);
                      }
                    }
                  );
                }, 3500);
              } else {
                th.showSwal2(
                  "auto-close",
                  "Erro",
                  data.err || data.message,
                  "error"
                );
              }
            })
            .catch((err) => {
              console.log(err);
              th.isLoading = false;
              th.showSwal2(
                "auto-close",
                "Erro",
                "Erro ao registrar ponto!",
                "error"
              );
              // location.reload()
            });
        })
        .catch((err) => {
          thi.showSwal2(
            "auto-close",
            "Erro",
            "Falha ao obter sua localização!",
            "error"
          );
        });
    },

    showSwal2(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          html: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    showSwal(type) {
      if (type === "success-message-recognition") {
        swal({
          title: `Muito Bom!`,
          text: "Reconhecimento facial realizado com sucesso!",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-success btn-fill",
          type: "success",
        }).then(() => {
          // location.reload()
        });
      } else if (type === "success-message-register") {
        swal({
          title: `Muito Bom!`,
          text: "Usuario cadastrato com sucesso!",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-success btn-fill",
          type: "success",
        }).then(() => {
          // location.reload()
        });
      } else if (type === "error-message") {
        swal({
          title: `Erro`,
          text: "Não conseguimos identifica-lo!",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-success btn-fill",
          type: "error",
        }).then(() => {
          this.setupMedia();
          this.loadCameras();
          // location.reload()
        });
      }
    },
    /* able(){
            bus.$emit('ableButtonEmail', true)
            bus.$emit('ativarMM', true)
        }, */
    closeModal(/* e */) {
      this.modals.modal3 = false;
      this.selected = "";
      this.errorResponse.status = false;
      this.errorResponse.message = "";
      this.successResponse.status = false;
      this.successResponse.message = "";
      this.stop();
      //            bus.$emit('relaodGuia', true)

      //            bus.$emit('success', "Paciente autorizado para procedimento(s).");
      //            bus.$emit('limpalist');
    },
    loadCameras() {
      this.cameras = [];
      navigator.mediaDevices
        .enumerateDevices()
        .then((deviceInfos) => {
          for (let i = 0; i !== deviceInfos.length; ++i) {
            let deviceInfo = deviceInfos[i];
            if (deviceInfo.kind === "videoinput") {
              this.cameras.push(deviceInfo);
            }
          }
          if (this.cameras.length > 0) {
            this.selected = this.cameras[0].deviceId;
            this.changeCamera(this.selected);
          }
        })
        .then(() => {
          if (!this.camerasListEmitted) {
            if (this.selectFirstDevice && this.cameras.length > 0) {
              this.deviceId = this.cameras[0].deviceId;
            }
            this.$emit("cameras", this.cameras);
            this.camerasListEmitted = true;
          }
        })
        .catch((error) => this.$emit("notsupported", error));
    },
    CapturarImagem() {
      const carregarDadosFacial = () => {
        return JSON.parse(this.$session.get("facial"));
      };
      let dadosFacial = carregarDadosFacial();

      if (this.dados.tipo === "E" && dadosFacial.tipo_batida === 2) {
        this.showSwal2(
          "auto-close",
          "Registro não autorizado",
          "Solicite ao seu RH liberação para registro de ponto Facial.",
          "error"
        );
        return;
      }

      this.isLoading = true;
      this.pause();
      let current = this;
      let img = this.capture();
      img = img.substr(22);
      const cpf = dadosFacial.cpf;

      const jsonn = new FormData();
      jsonn.append("image", img);
      jsonn.append("nrCpf", cpf);

      this.axios
        .post(`${process.env.VUE_APP_API_ADDRESS_REC_FACIAL}/classify`, jsonn)
        .then(function(response) {
          current.isLoading = false;
          if (
            response.data.default_face_matching_classification &&
            response.data.message == "User successfully registered"
          ) {
            // current.showSwal('success-message-register')
            current.registrarPonto(img);
          } else if (
            response.data.default_face_matching_classification &&
            response.data.message == "The classification succeeded"
          ) {
            // current.showSwal('success-message-recognition')
            current.registrarPonto(img);
          } else {
            current.showSwal("error-message");
            // current.registrarPonto(img)
          }
        })
        .finally(() => {})
        .catch(function(/* e */) {
          current.isLoading = false;
          // current.showSwal('error-message')
        });
    },
    legacyGetUserMediaSupport() {
      return (constraints) => {
        let getUserMedia =
          navigator.getUserMedia ||
          navigator.webkitGetUserMedia ||
          navigator.mozGetUserMedia ||
          navigator.msGetUserMedia ||
          navigator.oGetUserMedia;
        // Some browsers just don't implement it - return a rejected promise with an error
        // to keep a consistent interface
        if (!getUserMedia) {
          return Promise.reject(
            new Error("getUserMedia is not implemented in this browser")
          );
        }
        // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
        return new Promise(function(resolve, reject) {
          getUserMedia.call(navigator, constraints, resolve, reject);
        });
      };
    },
    /**
     * setup media
     */
    setupMedia() {
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = this.legacyGetUserMediaSupport();
      }
      this.testMediaAccess();
    },

    /**
     * change to a different camera stream, like front and back camera on phones
     */
    changeCamera(deviceId) {
      this.stop();
      this.$emit("camera-change", deviceId);
      this.loadCamera(deviceId);
    },
    /**
     * load the stream to the
     */
    loadSrcStream(stream) {
      if ("srcObject" in this.$refs.video) {
        // new browsers api
        this.$refs.video.srcObject = stream;
      } else {
        // old broswers
        this.source = window.HTMLMediaElement.srcObject(stream);
      }
      // Emit video start/live event
      this.$refs.video.onloadedmetadata = () => {
        this.$emit("video-live", stream);
      };
      this.$emit("started", stream);
    },
    /**
     * stop the selected streamed video to change camera
     */
    stopStreamedVideo(videoElem) {
      let stream = videoElem.srcObject;
      let tracks = stream.getTracks();
      tracks.forEach((track) => {
        // stops the video track
        track.stop();
        this.$emit("stopped", stream);
        this.$refs.video.srcObject = null;
        this.source = null;
      });
    },
    // stop the video
    stop() {
      if (this.$refs.video !== null && this.$refs.video.srcObject) {
        this.stopStreamedVideo(this.$refs.video);
      }
    },
    // start the video
    start() {
      if (this.deviceId) {
        this.loadCamera(this.deviceId);
      }
    },
    // pause the video
    pause() {
      if (this.$refs.video !== null && this.$refs.video.srcObject) {
        this.$refs.video.pause();
      }
    },
    // resume the video
    resume() {
      if (this.$refs.video !== null && this.$refs.video.srcObject) {
        this.$refs.video.play();
      }
    },
    /**
     * test access
     */
    testMediaAccess() {
      let constraints = { video: true };
      if (this.resolution) {
        constraints.video = {};
        constraints.video.height = this.resolution.height;
        constraints.video.width = this.resolution.width;
      }
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          //Make sure to stop this MediaStream
          let tracks = stream.getTracks();
          tracks.forEach((track) => {
            track.stop();
          });
          this.loadCameras();
        })
        .catch((error) => this.$emit("error", error));
    },
    /**
     * load the camera passed as index!
     */
    loadCamera(device) {
      let constraints = { video: { deviceId: { exact: device } } };
      if (this.resolution) {
        constraints.video.height = this.resolution.height;
        constraints.video.width = this.resolution.width;
      }
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.loadSrcStream(stream);
          setTimeout(() => {
            this.scrollToElement();
          }, 1000);
        })
        .catch((error) => this.$emit("error", error));
    },
    /**
     * capture screenshot
     */
    capture() {
      this.photo = this.getCanvas().toDataURL(this.screenshotFormat);
      return this.getCanvas().toDataURL(this.screenshotFormat);
    },
    /**
     * get canvas
     */
    getCanvas() {
      let video = this.$refs.video;
      if (!this.ctx) {
        let canvas = document.createElement("canvas");
        canvas.height = video.videoHeight;
        canvas.width = video.videoWidth;
        this.canvas = canvas;
        this.ctx = canvas.getContext("2d");
      }
      const { ctx, canvas } = this;
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      return canvas;
    },
    /**
     * Carregando imagem do paciente
     */
  },
  created() {
    this.carregarDados();
  },
  mounted() {
    this.setupMedia();
    this.loadCameras();
    setTimeout(() => {
      this.scrollToElement();
    }, 1500);
  },
};
</script>
<style scoped>
#vitrine {
  width: 100%;
}
.space {
  margin-top: 10 px;
}

.custom-button button {
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-button button i {
  margin-right: 8px;
  margin-bottom: 4px;
}
</style>
